import { useNavigate } from "react-router-dom";
import { theme } from "../theme.js";
import { getOrgIdFromStorage } from "../utils/storage.js";

export default function OrganizerBanner() {
  const navigate = useNavigate();
  
  const orgId = getOrgIdFromStorage();

  if (!orgId) return null;

  const handleClick = () => {
    navigate(`/organizers/${orgId}`);
  };

  return (
    <div style={styles.banner}>
      <div style={styles.content}>
        <p style={styles.text}>
          Vous êtes également inscrit dans une organisation.{" "}
          <button style={styles.link} onClick={handleClick}>
            cliquez ici
          </button>{" "}
          pour ouvrir la vue de l'organisateur.
        </p>
      </div>
    </div>
  );
}

const styles = {
  banner: {
    backgroundColor: theme.colors.light,
    borderBottom: `2px solid ${theme.colors.light}`,
    padding: `${theme.spacing.md} ${theme.spacing.xxl}`,
    textAlign: "center",
    boxShadow: theme.shadows.sm,
    position: "sticky",
    top: 0,
    zIndex: 1000,
    width: "100%",
  },
  content: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing.lg,
  },
  text: {
    margin: 0,
    fontSize: theme.fonts.size.sm,
    color: theme.colors.textInverted,
    fontWeight: theme.fonts.weight.medium,
  },
  link: {
    background: "none",
    border: "none",
    color: theme.colors.dark,
    fontWeight: theme.fonts.weight.bold,
    cursor: "pointer",
    textDecoration: "underline",
    padding: 0,
    fontSize: theme.fonts.size.sm,
    transition: "opacity 0.2s",
  },
};
